import TripDetailNewPath from './TripDetailNewPath';
export default TripDetailNewPath;
